import React from 'react';

const WizardProgressDots = ({ total = 0, current = 0, className = '' }) => {
  const dots = Array.from({ length: Math.max(0, total) });
  return (
    <div className={`flex gap-2 ${className}`}>
      {dots.map((_, i) => (
        <div
          key={i}
          className={`w-2 h-2 rounded-full ${i < current ? 'bg-succession-success' : i === current ? 'bg-succession-primary' : 'bg-succession-border'}`}
        />
      ))}
    </div>
  );
};

export default WizardProgressDots;


